import React, {useState, useEffect, useRef} from "react";
import PropTypes from "prop-types";
import {RTEWrapper, ContentWrapper} from "BaseComponents/Wrappers";
import {Paragraph, Ingress, H1, Bold} from "BaseComponents/Text/";
import {CrisisBanner} from "Components/CrisisBanner";
import ConfirmAndReset from "../LoginPage/ConfirmAndReset";
import Cookies from "js-cookie";
import {ButtonText, SecondarySubmitButton} from "BaseComponents/Button";
import {LoginButton} from "../LoginPage/styles/loginStyles";
import {useGlobal} from "reactn";

let ProfilePage = ({
                       Heading,
                       Preamble,
                       PublicAnnouncement,
                       CurrentUser,
                       Id: CurrentPageId,
                       UseOpenID,
                       HiText,
                       LogOutText
                   }) => {
    const [userIsConfirmed, setUserIsConfirmed] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [theme] = useGlobal("theme");
    const [aft, setAft] = useState(null);

    const {FirstName, LastName, IsConfirmed} = CurrentUser;

    let isADUser = Cookies.get("AdUser");

    const logOut = () => {
        setIsLoading(true);
        fetch(`/user/logoff`, {
            method: "POST",
            headers: {
                __RequestVerificationToken: aft,
                RequestVerificationToken: aft,
                "Content-Type": "application/json",
            },
        }).then(({ok}) => {
            if (ok) {
                location.reload();
            }
        });
    };
    useEffect(() => {
        setUserIsConfirmed(IsConfirmed);

        let profilePage = document.getElementById("profile-page");
        let antiForgeryTokenList = profilePage.querySelectorAll(
            "input[name=__RequestVerificationToken]"
        );
        if (antiForgeryTokenList !== undefined) {
            setAft(antiForgeryTokenList[0].value);
        }
    }, []);

    return (
        <>
            <H1 margin="0 0 15px 0">{Heading}</H1>
            <CrisisBanner {...PublicAnnouncement} />

            {Preamble && (
                <Ingress
                    marginSmall="0 0 15px 0"
                    margin="0 0 30px 0"
                    dangerouslySetInnerHTML={{
                        __html: Preamble,
                    }}
                ></Ingress>
            )}
            <ContentWrapper>
                {!isADUser ? (
                    <Paragraph display="block" margin="0 0 1.5rem 0">
                        Du kan endast hantera din användarprofil om du är inloggad som
                        AD-användare!
                    </Paragraph>
                ) : (
                    <>
                        <Paragraph display="block" fontSize="22px" margin="0 0 1.5rem 0">
                            {HiText}, {FirstName} {LastName}!
                        </Paragraph>

                        {!userIsConfirmed && (
                            <Paragraph display="block">
                                Välkommen till Frösundaportalen!
                                <br></br>
                                <br></br>
                                Nu är du ett litet steg från tillgång till Frösundas intranät.
                                <br></br>
                                <br></br>
                                För att du ska kunna få ett nytt lösenord i händelse av att du
                                glömmer det, vill vi be dig ange din privata e-postadress och
                                ditt privata mobilnummer här nedan.
                                <br></br>
                                <br></br>
                                Fyll också i det lösenord som du vill använda för ditt
                                Frösunda-konto i rutan ”Välj nytt lösenord”. Lösenordet används
                                sedan också till Utbildningsportalen (Learnifier) och
                                kvalitetssystemet TQM.
                            </Paragraph>
                        )}
                        {!UseOpenID &&
                            <ConfirmAndReset Reset={false} {...CurrentUser} aft={aft} CurrentPageId={CurrentPageId}/>}
                        <SecondarySubmitButton
                            bgColor={theme.colors.secondary}
                            onClick={logOut}
                            colorhover={theme.colors.secondary}
                            inverted
                            width="100%"
                            margin="3rem 0 0 0"
                            height="58px"
                        >
                            <ButtonText forcedFontSize="24px">{LogOutText}</ButtonText>
                        </SecondarySubmitButton>
                    </>
                )}
            </ContentWrapper>
        </>
    );
};

ProfilePage.propTypes = {
    Heading: PropTypes.string,
    Text: propTypes.string,
};

export default ProfilePage;
